import { motion } from "framer-motion";

const ITEMS = [
  {
    tag: "Perspective",
    date: "Feb 2026",
    title: "Institutional Capital in the AI Infrastructure Cycle",
    excerpt: "Hyperscale power, interconnection, and long-duration siting have replaced silicon supply as the binding constraint of the AI infrastructure build-out. We examine how disciplined investors underwrite the next decade.",
    author: "First Providence Research",
  },
  {
    tag: "Market Note",
    date: "Jan 2026",
    title: "Shandong Independents and the Global Crude Book",
    excerpt: "China's independent refiners are recalibrating around Brent-linked supply agreements — with implications for storage, hedging, and the cadence of VLCC discharge programs at Qingdao and Rizhao.",
    author: "China Management Team",
  },
  {
    tag: "Diligence",
    date: "Dec 2025",
    title: "West African Solar: Underwriting Sovereign Risk",
    excerpt: "A framework for PPA-anchored capital across Ghana, Côte d'Ivoire, and Senegal — with attention to currency, offtaker, and interconnection risks that most models miss.",
    author: "Institutional Risk",
  },
  {
    tag: "ESG",
    date: "Nov 2025",
    title: "From Compliance to Cash Flow: Integrating ESG into Real Assets",
    excerpt: "Why the highest-quality mixed-use developments now integrate environmental performance into their cap rates — not their marketing decks.",
    author: "Real Assets Group",
  },
  {
    tag: "Tokenization",
    date: "Oct 2025",
    title: "Preparing Institutional Vehicles for Regulated Tokenization",
    excerpt: "A conservative, compliance-forward view on how tokenization can unlock secondary liquidity for private fund interests without compromising governance.",
    author: "Digital Assets Working Group",
  },
  {
    tag: "Geopolitics",
    date: "Sep 2025",
    title: "The MENA Sovereign AI Compute Trade",
    excerpt: "Sovereign co-investment in AI training compute is reshaping the geography of capital. We map who is deploying, and against what strategic frames.",
    author: "Strategic Advisory",
  },
];

export default function Insights() {
  return (
    <div>
      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pt-32 pb-16">
        <div className="eyebrow">Insights & Perspectives</div>
        <h1 className="font-display text-5xl md:text-7xl mt-6 leading-[1.02] max-w-4xl">
          Editorial thinking, institutional lens.
        </h1>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {ITEMS.map((art, i) => (
            <motion.article
              key={art.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.05, duration: 0.6 }}
              className="bg-white border border-[#0B1F3A]/10 p-8 hover:shadow-lg hover:-translate-y-1 transition flex flex-col"
            >
              <div className="flex items-center justify-between text-[10px] uppercase tracking-[0.22em]">
                <span className="text-[#3399FF]">{art.tag}</span>
                <span className="text-[#5F6B7A]">{art.date}</span>
              </div>
              <h3 className="font-display text-2xl mt-6 text-[#0B1F3A] leading-snug">{art.title}</h3>
              <p className="mt-4 text-sm text-[#5F6B7A] leading-relaxed">{art.excerpt}</p>
              <div className="mt-auto pt-8 flex items-center justify-between border-t border-[#0B1F3A]/10">
                <div className="text-xs text-[#0B1F3A] font-medium">{art.author}</div>
                <div className="text-[10px] uppercase tracking-[0.28em] text-[#D4AF37]">Read →</div>
              </div>
            </motion.article>
          ))}
        </div>
      </section>
    </div>
  );
}
